module.exports = __webpack_public_path__ + "img/24.0d51b4e0.png";